import React, { FC } from "react";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import TextField from "shared/components/Form/TextField";
import { COLOR_BLACK } from "shared/theme/colors";
import { useFaqGroupDetails } from "../../../../context";

const General: FC = () => {
  const {
    groupTitle,
    onChangeGroupTitle,
  } = useFaqGroupDetails();

  return (
    <ContentSection title="General">
      <TextField
        id="groupTitle"
        label="Title"
        placeholder="Enter group title"
        fullWidth
        required
        value={groupTitle?.input.value}
        onChange={onChangeGroupTitle}
        errors={groupTitle?.input.errors}
        labelColor={COLOR_BLACK}
      />
    </ContentSection>);
};

export default General;
